// extracted by mini-css-extract-plugin
export var defaultWrapper = "_fl-3";
export var downloadButton = "_fl-4";
export var fileContainer = "_fl-9 _fl-7";
export var fileContainerBase = "_fl-7";
export var fileContainerFixedHeight = "_fl-8 _fl-7";
export var fileInfo = "_fl-5";
export var fileInfoWidthRestricted = "_fl-6";
export var fileType = "_fl-1";
export var fileTypeName = "_fl-2";
export var image = "_fl-0";
export var link = "_fl-b";
export var overflowEllipsis = "_fl-a";